//react
import React, { useMemo } from "react";
import { DataTable, SelectColumnFilter } from "./DataTable";
import { format } from "date-fns";

const defaultSortBy = [
  {
    id: "recordedDate",
    desc: true,
  },
];

const ClaimTable = ({ claims, onDetailsClick, isLoading, isError }) => {
  const tableColumns = React.useMemo(
    () => [
      {
        Header: "Claim Reference #",
        accessor: "claimNumber",
        // filter: "includesTrimmed",
        // sortType: alphaNumericCaseInsensitiveSortFunction,
        width: 150,
      },
      {
        Header: "Delivery ID",
        accessor: "deliveryId",
        // filter: "includesTrimmed",
        width: 130,
      },
      {
        Header: "Invoice",
        accessor: "invoiceNumber",
        // filter: "includesTrimmed",
        // sortType: alphaNumericCaseInsensitiveSortFunction,
      },
      {
        Header: "Recorded Date",
        accessor: "recordedDate",
        Cell: ({ value }) => format(value, "MM/dd/yyyy"),
        sortType: "datetime",
        disableFilters: true,
      },
      {
        Header: "Customer",
        accessor: "customer",
        // disableSortBy: true,
        // filter: "includesTrimmed",
        // sortType: alphaNumericCaseInsensitiveSortFunction,
        width: 230,
      },
      {
        Header: "Part Number",
        accessor: "partNumber",
        disableSortBy: true,
        // filter: "includesTrimmed",
      },
      {
        Header: "Route",
        accessor: "route",
        disableSortBy: true,
        // sortType: alphaNumericCaseInsensitiveSortFunction,
        // filter: "includesTrimmed",
      },
      {
        Header: "Type",
        accessor: "type",
        disableSortBy: true,
        Filter: SelectColumnFilter,
        // filter: "equals",
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Filter: SelectColumnFilter,
        // filter: "equals",
      },
      {
        Header: "Options",
        accessor: "claimMenu",
        Cell: ({ value }) => (
          <button
            className="btn btn-primary"
            onClick={(e) => {
              e.preventDefault();
              onDetailsClick(value);
            }}
          >
            Details
          </button>
        ),
        disableFilters: true,
        disableSortBy: true,
        width: 90, //same issue as other tables aside from order history table where we can't make it too small
      },
    ],
    [claims]
  );

  const tableData = useMemo(
    () =>
      claims.map((c) => ({
        claimNumber: c.claimNo,
        deliveryId: c.deliveryId,
        invoiceNumber: c.invoiceNumber,
        recordedDate: new Date(c.recDate),
        customer: c.customer,
        partNumber: c.partNo,
        route: c.route,
        type: c.type,
        status: c.stat,
        claimMenu: c.tranId,
      })),
    [claims]
  );

  return (
    <DataTable
      columns={tableColumns}
      data={tableData}
      isLoading={isLoading}
      isError={isError}
      initialState={{
        sortBy: defaultSortBy,
      }}
      slotProps={{
        topToolbar: { disabled: true },
      }}
    />
  );
};

export default ClaimTable;
